var chunkMapping = {
	"46": [
		236046
	],
	"57": [
		419057
	],
	"70": [
		587070
	],
	"90": [
		900090
	],
	"126": [
		292126
	],
	"139": [
		538139
	],
	"150": [
		624150
	],
	"193": [
		52631,
		573353
	],
	"282": [
		196282
	],
	"292": [
		327292
	],
	"331": [
		602331
	],
	"340": [
		762340
	],
	"383": [
		134383
	],
	"404": [
		267404
	],
	"447": [
		777447
	],
	"451": [
		195451
	],
	"503": [
		74503
	],
	"540": [
		94021,
		157960,
		174440,
		253906,
		424794,
		673854,
		963675
	],
	"551": [
		113551
	],
	"593": [
		193593
	],
	"751": [
		942751
	],
	"780": [
		426780
	],
	"794": [
		718794
	],
	"831": [
		817831
	],
	"911": [
		900292
	],
	"953": [
		55953
	],
	"957": [
		213957
	],
	"974": [
		797974
	],
	"992": [
		981992
	]
};
var idToExternalAndNameMapping = {
	"52631": [
		"default",
		"./layout",
		639694
	],
	"55953": [
		"default",
		"./SetupSidebar",
		37162
	],
	"74503": [
		"default",
		"./SCMConfigurationPage",
		899918
	],
	"94021": [
		"default",
		"./Translations",
		639694
	],
	"113551": [
		"default",
		"./scan-projects",
		99838
	],
	"134383": [
		"default",
		"./LibrariesPage",
		899918
	],
	"157960": [
		"default",
		"./ConfirmationRoleAction",
		639694
	],
	"174440": [
		"default",
		"./state",
		639694
	],
	"193593": [
		"default",
		"./ip-allowlist-panel",
		99838
	],
	"195451": [
		"default",
		"./adr-integrations-panel",
		99838
	],
	"196282": [
		"default",
		"./AddAgentsApp",
		610536
	],
	"213957": [
		"default",
		"./audit-log",
		99838
	],
	"236046": [
		"default",
		"./UserPermissions",
		52810
	],
	"253906": [
		"default",
		"./filters",
		639694
	],
	"267404": [
		"default",
		"./impersonation-panel",
		99838
	],
	"292126": [
		"default",
		"./Observability",
		41046
	],
	"327292": [
		"default",
		"./repositories-panel",
		899918
	],
	"419057": [
		"default",
		"./AttackEventsPage",
		538850
	],
	"424794": [
		"default",
		"./accessControl",
		639694
	],
	"426780": [
		"default",
		"./RepositoriesPage",
		899918
	],
	"538139": [
		"default",
		"./agent-keys",
		99838
	],
	"573353": [
		"default",
		"./RoleSwitch",
		639694
	],
	"587070": [
		"default",
		"./mfa-panel",
		99838
	],
	"602331": [
		"default",
		"./observability-panel",
		99838
	],
	"624150": [
		"default",
		"./mfa-banner",
		99838
	],
	"673854": [
		"default",
		"./Tags",
		639694
	],
	"718794": [
		"default",
		"./licenses-panel",
		99838
	],
	"762340": [
		"default",
		"./ReportDashboard",
		367466
	],
	"777447": [
		"default",
		"./EventModal",
		37162
	],
	"797974": [
		"default",
		"./app",
		211934
	],
	"817831": [
		"default",
		"./integrations-panel",
		99838
	],
	"900090": [
		"default",
		"./SCMOnboardingPage",
		899918
	],
	"900292": [
		"default",
		"./AppConfigApp",
		37162
	],
	"942751": [
		"default",
		"./RemediationSummary",
		367466
	],
	"963675": [
		"default",
		"./Modals",
		639694
	],
	"981992": [
		"default",
		"./AgentsDashboard",
		610536
	]
};
var idToRemoteMap = {
	"52631": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"55953": [
		{
			"externalType": "script",
			"name": "platformAppConfig"
		}
	],
	"74503": [
		{
			"externalType": "script",
			"name": "platformRepositories"
		}
	],
	"94021": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"113551": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"134383": [
		{
			"externalType": "script",
			"name": "platformRepositories"
		}
	],
	"157960": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"174440": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"193593": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"195451": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"196282": [
		{
			"externalType": "script",
			"name": "agentsDashboardMfe"
		}
	],
	"213957": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"236046": [
		{
			"externalType": "script",
			"name": "platformUserSettings"
		}
	],
	"253906": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"267404": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"292126": [
		{
			"externalType": "script",
			"name": "adrContrastGraph"
		}
	],
	"327292": [
		{
			"externalType": "script",
			"name": "platformRepositories"
		}
	],
	"419057": [
		{
			"externalType": "script",
			"name": "attackEvents"
		}
	],
	"424794": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"426780": [
		{
			"externalType": "script",
			"name": "platformRepositories"
		}
	],
	"538139": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"573353": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"587070": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"602331": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"624150": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"673854": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"718794": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"762340": [
		{
			"externalType": "script",
			"name": "platformReports"
		}
	],
	"777447": [
		{
			"externalType": "script",
			"name": "platformAppConfig"
		}
	],
	"797974": [
		{
			"externalType": "script",
			"name": "platformAuthz"
		}
	],
	"817831": [
		{
			"externalType": "script",
			"name": "orgSettings"
		}
	],
	"900090": [
		{
			"externalType": "script",
			"name": "platformRepositories"
		}
	],
	"900292": [
		{
			"externalType": "script",
			"name": "platformAppConfig"
		}
	],
	"942751": [
		{
			"externalType": "script",
			"name": "platformReports"
		}
	],
	"963675": [
		{
			"externalType": "script",
			"name": "contrastBase"
		}
	],
	"981992": [
		{
			"externalType": "script",
			"name": "agentsDashboardMfe"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"52631": {
		"shareScope": "default",
		"name": "./layout",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"55953": {
		"shareScope": "default",
		"name": "./SetupSidebar",
		"externalModuleId": 37162,
		"remoteName": "platformAppConfig"
	},
	"74503": {
		"shareScope": "default",
		"name": "./SCMConfigurationPage",
		"externalModuleId": 899918,
		"remoteName": "platformRepositories"
	},
	"94021": {
		"shareScope": "default",
		"name": "./Translations",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"113551": {
		"shareScope": "default",
		"name": "./scan-projects",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"134383": {
		"shareScope": "default",
		"name": "./LibrariesPage",
		"externalModuleId": 899918,
		"remoteName": "platformRepositories"
	},
	"157960": {
		"shareScope": "default",
		"name": "./ConfirmationRoleAction",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"174440": {
		"shareScope": "default",
		"name": "./state",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"193593": {
		"shareScope": "default",
		"name": "./ip-allowlist-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"195451": {
		"shareScope": "default",
		"name": "./adr-integrations-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"196282": {
		"shareScope": "default",
		"name": "./AddAgentsApp",
		"externalModuleId": 610536,
		"remoteName": "agentsDashboardMfe"
	},
	"213957": {
		"shareScope": "default",
		"name": "./audit-log",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"236046": {
		"shareScope": "default",
		"name": "./UserPermissions",
		"externalModuleId": 52810,
		"remoteName": "platformUserSettings"
	},
	"253906": {
		"shareScope": "default",
		"name": "./filters",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"267404": {
		"shareScope": "default",
		"name": "./impersonation-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"292126": {
		"shareScope": "default",
		"name": "./Observability",
		"externalModuleId": 41046,
		"remoteName": "adrContrastGraph"
	},
	"327292": {
		"shareScope": "default",
		"name": "./repositories-panel",
		"externalModuleId": 899918,
		"remoteName": "platformRepositories"
	},
	"419057": {
		"shareScope": "default",
		"name": "./AttackEventsPage",
		"externalModuleId": 538850,
		"remoteName": "attackEvents"
	},
	"424794": {
		"shareScope": "default",
		"name": "./accessControl",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"426780": {
		"shareScope": "default",
		"name": "./RepositoriesPage",
		"externalModuleId": 899918,
		"remoteName": "platformRepositories"
	},
	"538139": {
		"shareScope": "default",
		"name": "./agent-keys",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"573353": {
		"shareScope": "default",
		"name": "./RoleSwitch",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"587070": {
		"shareScope": "default",
		"name": "./mfa-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"602331": {
		"shareScope": "default",
		"name": "./observability-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"624150": {
		"shareScope": "default",
		"name": "./mfa-banner",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"673854": {
		"shareScope": "default",
		"name": "./Tags",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"718794": {
		"shareScope": "default",
		"name": "./licenses-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"762340": {
		"shareScope": "default",
		"name": "./ReportDashboard",
		"externalModuleId": 367466,
		"remoteName": "platformReports"
	},
	"777447": {
		"shareScope": "default",
		"name": "./EventModal",
		"externalModuleId": 37162,
		"remoteName": "platformAppConfig"
	},
	"797974": {
		"shareScope": "default",
		"name": "./app",
		"externalModuleId": 211934,
		"remoteName": "platformAuthz"
	},
	"817831": {
		"shareScope": "default",
		"name": "./integrations-panel",
		"externalModuleId": 99838,
		"remoteName": "orgSettings"
	},
	"900090": {
		"shareScope": "default",
		"name": "./SCMOnboardingPage",
		"externalModuleId": 899918,
		"remoteName": "platformRepositories"
	},
	"900292": {
		"shareScope": "default",
		"name": "./AppConfigApp",
		"externalModuleId": 37162,
		"remoteName": "platformAppConfig"
	},
	"942751": {
		"shareScope": "default",
		"name": "./RemediationSummary",
		"externalModuleId": 367466,
		"remoteName": "platformReports"
	},
	"963675": {
		"shareScope": "default",
		"name": "./Modals",
		"externalModuleId": 639694,
		"remoteName": "contrastBase"
	},
	"981992": {
		"shareScope": "default",
		"name": "./AgentsDashboard",
		"externalModuleId": 610536,
		"remoteName": "agentsDashboardMfe"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}